import React, { useState } from 'react'
import useRenderEvent from '@/core/hooks/useRenderEvent'

import { ReactComponent as BagdeIcon } from '@/assets/icons/badge-icon.svg'

import contactsService from '@/app-domains/contacts/contacts.service'

import { ReactComponent as EllipsisIcon } from '@/assets/icons/ellipsis-icon.svg'
import { EditContactLabelDropdownMenu } from './EditDropdownMenu/EditDropdownMenu'
import dropdownService from '@/components/DropdownMenu/dropdown.service'
import classNames from 'classnames'
import './ContactLabelCard.scoped.sass'
import contactslabelsService from '@/app-domains/contactslabels/contactslabels.service'

const ContactLabelCard = (props) => {
  const { label, selectedLabel } = props
  const [menuOpened, setMenuOpened] = useState(false)
  const [menuOpenedEvent, setMenuOpenedEvent] = useState(false)

  const toggleMenuOpen = (e) => {
    e.stopPropagation()
    if (dropdownService.isOpenedForThisTarget(e)) {
      setMenuOpened(false)
      setMenuOpenedEvent(false)
      return dropdownService.close()
    }
    
    setMenuOpenedEvent(e)
    setMenuOpened(Date.now())
  }

  function selectLabel () {
    contactslabelsService.switchToContactsBelongingToLabel(label)
  }

  useRenderEvent(['DROPDOWN:CLOSE'], () => {
    setMenuOpened(false)
    setMenuOpenedEvent(false)
  })

  return (
    <li id={'label-button' + label.id} className={classNames(
      {
        active: selectedLabel?.id && selectedLabel.id === label.id,
        'menu-opened': menuOpened
      })} onClick={() => selectLabel(label)}
    >
      <div className="label-left">
        <span className='label-icon'>
          <BagdeIcon />
        </span>
        <span className='label-name' title={label.name}>
          {label.name}
        </span>
      </div>
      <div className='label-button-right-menu'>
        <div className="label-right">
          {contactsService.getContactsForLabel(label).length}
        </div>
        <div className="label-button-dropdown-button">
          <EllipsisIcon onClick={toggleMenuOpen}/>
          { menuOpened && <EditContactLabelDropdownMenu label={label} event={menuOpenedEvent}/> }
        </div>
      </div>
    </li>
  )
}

export default ContactLabelCard
